$('.faq .faq-question').on('click', function () {
    var isActive = $( this ).parent().hasClass('active');

    $('.faq.active').removeClass('active');

    if (!isActive) {
        $( this ).parent().addClass('active');
    } 
});

$('.payment-modal-trigger').on('click', function () {
    $('.payment-modal').addClass('active');
    $('body').addClass('overflow-hidden');
});

$('.payment-modal-close').on('click', function () {
    $('.payment-modal.active').removeClass('active');
    $('body').removeClass('overflow-hidden');
});

$('.payment-modal').on('click', function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('body').removeClass('overflow-hidden');
    }
});

$(".discount-badge a").on('click', function () {
    var $div = $(this).parent().find('.discount-info');

    if ($div.hasClass('active')) {
        $div.removeClass('active');
    } else {
        $('.discount-info.active').removeClass('active');
        $div.addClass('active');
    }

    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $(this).addClass('active');
    }
});

var recommendations = $('.recommendations');
var banners = $('.custom-slider ul');

var next = '<div class="right-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8 8L1 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'

var prev = '<div class="left-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15L1 8L8 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';


// recommendations.slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     prevArrow: prev,
//     nextArrow: next,
//     mobileFirst: true,
//     responsive: [
//         {
//             breakpoint: 790,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 1440,
//             settings: {
//               slidesToShow: 4,
//               slidesToScroll: 1
//             }
//         }
//     ]
// });
// recommendations.css('opacity', 1);

var bannerSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: prev,
    nextArrow: next,
    mobileFirst: true,
    lazyLoad: 'ondemand',
    adaptiveHeight: true
}

if ($(".slide-container.background").length != $(".slide-container").length) {
    bannerSettings["autoplay"] = false;
}

if ($( window ).width() < 1024) {
    bannerSettings["adaptiveHeight"] = false;
}

$( window ).on( "resize", function() {
    if ($( window ).width() < 1024) {
        bannerSettings["adaptiveHeight"] = false;
    }
});

if (!Shopify.designMode && banners) {
    banners.slick(bannerSettings);
}

document.addEventListener('shopify:section:load', (e) => {
  console.log(e);
});

$('.tt-btn-quickadd').on('click', function () {
    $(this).parent().submit();
});

$( ".dropdown-menu" ).mouseleave(function() {
    $(this).parent().removeClass('active');
});

$(".custom-tab .nav-item a.nav-link").on("click", function () {
    let id = $(this).data('link');
    $(".custom-tab .nav-item a.nav-link").removeClass("active");
    $(this).addClass("active");
    $(".tab-content .tab-pane").removeClass("active");
    $(`.tab-content #${id}`).addClass("active");
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.ufe-core').then(() => {
    var cart = $('<svg width="29" height="26" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-cart"><path d="M10 26C11.1046 26 12 25.1046 12 24C12 22.8954 11.1046 22 10 22C8.89543 22 8 22.8954 8 24C8 25.1046 8.89543 26 10 26Z" fill="#231F20"/><path d="M23 26C24.1046 26 25 25.1046 25 24C25 22.8954 24.1046 22 23 22C21.8954 22 21 22.8954 21 24C21 25.1046 21.8954 26 23 26Z" fill="#231F20"/><path d="M5.28572 6H27.7143L24.4144 17.5494C24.295 17.9673 24.0428 18.335 23.6958 18.5967C23.3488 18.8584 22.926 19 22.4914 19H10.5086C10.074 19 9.65119 18.8584 9.30421 18.5967C8.95723 18.335 8.70495 17.9673 8.58556 17.5494L4.06436 1.72528C4.00467 1.51633 3.87853 1.33251 3.70504 1.20165C3.53155 1.07079 3.32015 1 3.10284 1H1" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    
    setTimeout(function () {
        $target = $("#product-single-info form[action*='/cart/add']");
        $default_atc_btn = $("#product-single-info .tt-row-custom-01");
        $sold_out = $("#product-single-info .tt-add-info .availability .sold_out:not(.hide)").length;
        $backorder = $("#product-single-info .tt-add-info .availability .backorder").length;

        if ($('.ufe-widget + form').length > 0 && $sold_out == 0 && $backorder == 0) {
            // $default_atc_btn.hide();
        }    
    
        $('.ufe-core input[type="checkbox"]').on('change',function() {
            var len = $('.ufe-core input[type="checkbox"]:checked').length;     
        
            if (len == 0) {
                $default_atc_btn.show();
            } else {
                $default_atc_btn.hide();
            }
        });
    }, 500);


    var frequently = $('.shopify-section + .ufe-widget');
    frequently.addClass('frequently');
    
    $( "<span class='plus'> + </span>").insertBefore(frequently.find('.upsellWrapper.ufe-normal:not(:first)'));

    setTimeout(function () { cart.insertBefore($(".ufe-btn:not(.ufe-danger)").find("span")); }, 500)

    var frequently_products = frequently.find('.upsellWrapper');

    for (var fp = 0; fp < frequently_products.length; fp++) {
        // console.log($(frequently_products[fp]));
        // var discount = $(frequently_products[fp]).find('.udiscount_unitPrice_wrapper');

        // if (discount.text() == "") {
        //     frequently_products[fp].find("span").css('color', '#BAAD7D');
        // }
    }

});

// waitForElm('.frequently .ufe-buyButtons .ufe-btn').then(() => {
//     setTimeout(function () { cart.insertBefore($(".ufe-btn:not(.ufe-danger)").find("span")); }, 500)
// });


waitForElm('.frequently .upsellPrice.ufe-price').then(() => {
    setTimeout(function () { 
        var prices = $(".frequently .upsellPrice.ufe-price");

        for (let i = 0; i < prices.length; i++) {
            var price = $(prices[i]);    
            var old_price = parseFloat(price.find('span:last-child').text().replace("$", "").replace(",", ""));
            var new_price = parseFloat(price.find('span:first-child').text().replace("$", "").replace(",", ""));
            var saving = (old_price - new_price).toFixed(2);
    
            if (saving > 0) {
                price.parent().find('.udiscount_unitPrice_wrapper').append(`<div class="saving-tag mt-2 ml-2"><span class="position-relative">SAVE ${saving}</span></div>`)
            }
        }
    }, 1000)
});

$('.shopifyfiltres-js li').on('click touch', function () {
  // console.log('triggered filter');
});


$(document).on('click', '.collection-sidebar-section .tt-list-row__first-item', function (e) {
    const item = $(this);

    if (item.hasClass('active')) {
        item.removeClass('active');
        item.next('.tt-list-row__second').removeClass('open');
        return;
    }

    item.closest('.tt-list-row__first').find('.tt-list-row__first-item').removeClass('active');
    item.closest('.tt-list-row__first').find('.tt-list-row__second').removeClass('open');
    item.next('.tt-list-row__second').addClass('open');
    item.addClass('active');
});

$(document).on('click', '.collection-sidebar-section .tt-list-row__second-item', function (e) {
    const item = $(this);

    if (item.hasClass('active')) {
        item.removeClass('active');
        item.next('.tt-list-row__third').removeClass('open');
        return;
    }

    item.closest('.tt-list-row__second').find('.tt-list-row__second-item').removeClass('active');
    item.closest('.tt-list-row__second').find('.tt-list-row__third').removeClass('open');
    $(this).next('.tt-list-row__third').addClass('open');
    item.addClass('active');
});

let $level1 = null;
let $level2 = null;
let $level3 = null;

const $currentCollection = $('.current-collection');

if ($currentCollection.length > 0) {
    $level3 = $currentCollection.closest('.tt-list-row__third')
    $level2 = $currentCollection.closest('.tt-list-row__second')
    $level1 = $currentCollection.closest('.tt-list-row__first')

    if ($level3) {
        // find prev sibling and add active class
        $level3.prev().addClass('active current-collection');
        $level3.addClass('open');
    }

    if ($level2) {
        // find prev sibling and add active class
        $level2.prev().addClass('active current-collection');
        $level2.addClass('open');
    }

    if ($level1) {
        // find prev sibling and add active class
        $level1.prev().addClass('active current-collection');
    }
}





